import React from "react";
import { observer } from "mobx-react";

export const HUD = observer(({ mobX, children }) => {
  return <div className="HUD p-0 shared-scene-sizing scene-canvas-cover">{children}</div>;
});
